import 'rc-slider/assets/index.css';

import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import { PriceSlider } from './PriceSlider';
import AppContext from '../../../AppContext';
import Constants from './Constants';
import ProcSelect from './ProcSelect';

export default class SettingContent extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.inputs = [];
    this.state = {
      priceChanged: false,
    };
  }

  componentDidMount() {
    const input = this.inputs.find(Boolean);
    if (input) {
      input.focus();
    }
  }

  render() {
    return (
      <div className={'proc-ice-field-content setting'}>
        <div className={`proc-contents padding ${this.props.research ? 'research-bg-color' : 'tertiary100-bg-color'}`}>
          <div className={`proc-outer`}>
            <div className={'proc-inner small status'}>
              <div className="header">
                <div className="left">
                  <div className={'weather secondary100-fill-color'}>
                    {Constants.getWetherSvg(this.props.iceCtx.weather)}
                  </div>
                  <div className={'temperature secondary100-color'}>
                    <span className={'proc-huge-font'}>{this.props.iceCtx.temperature}</span>
                    <span className={'proc-medium-font'}>ど</span>
                  </div>
                </div>
                <div className="center">
                  <img className="image" src={Constants.getStatusWagonIcon(this.props.wagon)} />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`setting-container gray10-bg-color ${
              this.props.research ? '' : 'border-top secondary20-border-color'
            }`}
          >
            <div className={'proc-outer'}>
              <div className={'proc-inner small'}>
                <div className={'title center-aligned proc-small-font gray100-color'}>せっていしよう</div>
                <div className={'status-container'}>
                  <div className={'status-icon'}>
                    <img src={this.props.iceCtx.place >= 0 ? Constants.getPlaceIcon(this.props.iceCtx.place) : ''} />
                  </div>
                  <div className={'status-icon'}>
                    <img src={this.props.iceCtx.ice >= 0 ? Constants.getIceImage(this.props.iceCtx.ice) : ''} />
                  </div>
                  <div className={'status-icon'}>
                    <div className={'price gray30-color'}>{this.props.iceCtx.price}</div>
                  </div>
                </div>
                <table className={'proc-table fixed'}>
                  <thead>
                    <tr>
                      <th width={'50%'} className={'secondary100-color proc-small-font'}>
                        ばしょ
                      </th>
                      <th width={'50%'} className={'secondary100-color proc-small-font'}>
                        アイス
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className={'value'}>{this._renderPlaceSelect()}</td>
                      <td className={'value'}>{this._renderIceSelect()}</td>
                    </tr>
                  </tbody>
                </table>

                {this._renderPrice()}
              </div>
            </div>
          </div>
        </div>

        <Footer.action className="white-bg-color">
          <Button.normal onClick={this.props.onPreviousClick}>
            <ButtonIcon.back />
          </Button.normal>

          <Button.attention
            disabled={
              this.props.iceCtx.place < 0 ||
              this.props.iceCtx.ice < 0 ||
              (this.props.changableSetting === 2 && !this.state.priceChanged)
            }
            onClick={this.props.onNextClick}
          >
            <ButtonIcon.action />
          </Button.attention>
        </Footer.action>
      </div>
    );
  }

  _renderNextButton() {
    if (this.props.iceCtx.place < 0 || this.props.iceCtx.ice < 0) {
      return <Button.attention disabled>つぎへ</Button.attention>;
    }
    return <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>;
  }

  _renderPlaceSelect() {
    let changable = true;
    if (this.props.research && this.props.changableSetting >= 0) {
      changable = 0 === this.props.changableSetting;
    }
    if (changable) {
      return (
        <ProcSelect
          innerRef={r => {
            this.inputs[0] = r;
          }}
          title={'ばしょ'}
          value={this.props.iceCtx.place}
          images={Constants.getPlaceIcons()}
          labels={Constants.PLACE_LABELS}
          tabIndex={0}
          onSelected={this.props.onPlaceChange}
        />
      );
    }
    return Constants.PLACE_LABELS[this.props.iceCtx.place];
  }

  _renderIceSelect() {
    let changable = true;
    if (this.props.research && this.props.changableSetting >= 0) {
      changable = 1 === this.props.changableSetting;
    }
    if (changable) {
      return (
        <ProcSelect
          innerRef={r => {
            this.inputs[1] = r;
          }}
          title={'アイス'}
          value={this.props.iceCtx.ice}
          images={Constants.getIceImages()}
          labels={Constants.ICE_LABELS}
          tabIndex={0}
          onSelected={this.props.onIceChange}
        />
      );
    }
    return Constants.ICE_LABELS[this.props.iceCtx.ice];
  }

  _renderPriceSlider() {
    let changable = true;
    if (this.props.research && this.props.changableSetting >= 0) {
      changable = 2 === this.props.changableSetting;
    }
    if (changable) {
      return (
        <PriceSlider
          value={this.props.iceCtx.price}
          min={Constants.MIN_PRICE}
          max={Constants.MAX_PRICE}
          step={Constants.PRICE_STEP}
          onChange={this._onPriceChange.bind(this)}
        />
      );
    }
    return (
      <span className={'proc-large-font'}>
        {this.props.iceCtx.price}
        <span className={'yen-postfix proc-small-font'}>えん</span>
      </span>
    );
  }

  _renderPreviousButton() {
    if (!this.props.onPreviousClick) {
      return <span />;
    }
    return (
      <Button.normal onClick={this.props.onPreviousClick}>
        <ButtonIcon.back />
      </Button.normal>
    );
  }

  _renderPrice() {
    return (
      <table className={'proc-table'}>
        <thead>
          <tr>
            <th>ねだん</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={'value'}>{this._renderPriceSlider()}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  _onPriceChange(price) {
    this.context.soundController.sePlay('nedan_bar');
    this.setState({ priceChanged: true });
    if (this.props.onPriceChange) {
      this.props.onPriceChange(price);
    }
  }
}

SettingContent.propTypes = {
  iceCtx: PropTypes.object,
  research: PropTypes.bool,
  changableSetting: PropTypes.number,
  wagon: PropTypes.number,
  title: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onPlaceChange: PropTypes.func,
  onIceChange: PropTypes.func,
  onPriceChange: PropTypes.func,
  onWagonChange: PropTypes.func,
};

SettingContent.defaultProps = {};
